module.exports = "https://r.nearpod.com/assets/media/image/nearpod-video-icon-ebf9bb57dfb863c8f4c8c28c6478c10e.svg";